"use client";

import { useQuery } from "@tanstack/react-query";
import { useIntl } from "react-intl";

import { useClientEnvironment } from "~/app/environment/client";
import { environmentOptions } from "~/queries/environment/environment.options";

/**
 * A locale's activity keywords, shared by every autocomplete instead of one request each.
 * Defaults to the app locale, which matches the home page's prefetch key — pass a locale
 * only for a component scoped to one that is not the app's.
 */
export const useActivityKeywords = (locale?: string) => {
  const { HANDSHAKE_ENV } = useClientEnvironment();
  const { locale: appLocale } = useIntl();

  return useQuery(
    environmentOptions.queries.activityKeywords({
      handshake: HANDSHAKE_ENV,
      locale: locale ?? appLocale,
    }),
  );
};
